import { _ as _sfc_main } from "./VaDatePickerCell.vue_vue_type_script_lang-7b8c6cd0.mjs";
import { openBlock, createElementBlock, normalizeStyle, normalizeClass, withKeys, withModifiers, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaDatePickerCell_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.hidden ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "va-date-picker-cell va-date-picker-cell_clear",
    style: normalizeStyle(`--va-0-bg: ${String(_ctx.bg)};--va-1-text-color-computed: ${String(_ctx.textColorComputed)}`)
  }, null, 4)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["va-date-picker-cell", {
      "va-date-picker-cell_other-month": _ctx.otherMonth,
      "va-date-picker-cell_today": _ctx.highlightToday && _ctx.today,
      "va-date-picker-cell_in-range": _ctx.inRange,
      "va-date-picker-cell_disabled": _ctx.disabled,
      "va-date-picker-cell_highlighted-weekend": _ctx.highlightWeekend && _ctx.weekend,
      "va-date-picker-cell_selected": _ctx.selected,
      "va-date-picker-cell_focused": _ctx.focused,
      "va-date-picker-cell_readonly": _ctx.readonly
    }]),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args)),
    onKeypress: _cache[1] || (_cache[1] = withKeys(withModifiers((...args) => _ctx.onClick && _ctx.onClick(...args), ["prevent", "stop"]), ["space", "enter"])),
    style: normalizeStyle(`--va-0-bg: ${String(_ctx.bg)};--va-1-text-color-computed: ${String(_ctx.textColorComputed)}`)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 38));
}
const VaDatePickerCell = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaDatePickerCell as V
};

import '../../../../VaDatePickerCell.css';
//# sourceMappingURL=VaDatePickerCell-964e2f74.mjs.map
